export default __webpack_public_path__ + "static/media/Clean-Room.1e123553.jpg";